import { render, staticRenderFns } from "./SdtFaculty.vue?vue&type=template&id=54f5b6c3&scoped=true"
import script from "./SdtFaculty.vue?vue&type=script&lang=js"
export * from "./SdtFaculty.vue?vue&type=script&lang=js"
import style0 from "./SdtFaculty.vue?vue&type=style&index=0&id=54f5b6c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f5b6c3",
  null
  
)

export default component.exports